import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    TemplateRef,
    computed,
    inject,
    input,
    output,
} from '@angular/core';
import { TelXLPanelComponent } from '@dxp/elements';
import {
    IDirectoryListing,
    IDirectoryListingEvent,
    IDirectoryListingSelection,
} from '@dxp/core/models';
import { FormatDurationPipe } from '@dxp/core/pipes';
import { AvatarVariant, ListingMode, MediaType } from '@dxp/core/types';
import { CONTACT_STORE } from '@dxp/core/stores';
import { TelXLDirectoryListingDefaultItemComponent } from './directory-listing-default-item/directory-listing-default-item.component';
import { TelXLDirectoryListingInternalItemComponent } from './directory-listing-internal-item/directory-listing-internal-item.component';
import { TelXLDirectoryListingIvrItemComponent } from './directory-listing-ivr-item/directory-listing-ivr-item.component';

@Component({
    selector: 'telxl-shared-directory-listing-item',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        TelXLPanelComponent,
        TelXLDirectoryListingDefaultItemComponent,
        TelXLDirectoryListingInternalItemComponent,
        TelXLDirectoryListingIvrItemComponent,
    ],
    providers: [FormatDurationPipe],
    templateUrl: './directory-listing-item.component.html',
    styleUrl: './directory-listing-item.component.scss',
})
export class TelXLDirectoryListingItemComponent {
    readonly #contactStore = inject(CONTACT_STORE);

    mode = input<ListingMode[]>([]);
    source = input.required<AvatarVariant>();
    item = input.required<IDirectoryListing>();
    customButtonTemplate = input<TemplateRef<any>>();
    displayMediaIcons = input<MediaType[]>([]);
    highlight = input<boolean>(false);
    selected = input<IDirectoryListingSelection>({
        selected: false,
        item: ['voice'],
    });
    template = input<'default' | 'internal' | 'ivr'>('default');
    view = input<'contact' | 'presence' | 'none'>('contact');
    disabled = input<boolean>(false);
    selectedChange = output<IDirectoryListingEvent>();

    readonly filteredMediaIcons = computed<MediaType[]>(() =>
        this.displayMediaIcons().filter(icon => {
            const item = this.item?.();

            switch (icon) {
                case 'Voice':
                    return item.phoneNumber && item.phoneNumber.length > 0;
                case 'Email':
                    return item.email && item.email.length > 0;
                default:
                    return false;
            }
        }),
    );

    cardSelected() {
        /**
         * Pass the contact information to the store
         */
        this.#contactStore.updateSelectedContact(this.item());

        if (this.mode().includes('card')) {
            this.selectedChange.emit({ type: 'selection', item: this.item() });
        }
    }
}
